<script setup>
import { useRouter } from 'vue-router';
import { ROUTES } from '@/router/routeNames';

const router = useRouter();

const goBack = () => {
  router.back();
};

const goHome = () => {
  router.push({ name: ROUTES.DASHBOARD });
};
</script>

<template>
  <div class="flex justify-center items-center px-4 min-h-screen bg-gray-50 dark:bg-gray-900 sm:py-12 sm:px-6 lg:px-8">
    <div class="w-full max-w-md text-center">
      <div class="mb-8">
        <!-- 404 Icon/Illustration -->
        <div class="mx-auto mb-6 w-48 h-48">
          <svg class="w-full h-full text-indigo-500" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 4.75L19.25 9L12 13.25L4.75 9L12 4.75Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M9.25 12L4.75 15L12 19.25L19.25 15L14.6722 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M12 13.5V19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </div>

        <!-- Error Code -->
        <h1 class="text-9xl font-extrabold tracking-widest text-indigo-600 dark:text-indigo-400">404</h1>

        <!-- Error Message -->
        <h2 class="mt-4 text-3xl font-bold text-gray-900 dark:text-white">Page Not Found</h2>
        <p class="mt-6 text-base text-gray-600 dark:text-gray-300">
          The page you're looking for doesn't exist or has been moved.
        </p>

        <!-- Action Buttons -->
        <div class="flex justify-center mt-10 space-x-4">
          <button
            @click="goBack"
            class="px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md border border-transparent shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 dark:focus:ring-offset-gray-900"
          >
            Go Back
          </button>
          <button
            @click="goHome"
            class="px-4 py-2 text-sm font-medium text-gray-700 bg-white rounded-md border border-gray-300 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 dark:bg-gray-800 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-700 dark:focus:ring-offset-gray-900"
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
